import EaseLive from "@ease-live/ease-live-bridge-web";
import { path } from "ramda";
export default function setupEaseLive(obj) {
  let { player, playlist, videoEl } = obj;

  let clientUrl = path(["0", "sources", "0", "easeLiveWebAppUrl"])(playlist);

  if (clientUrl == null || clientUrl == "") {
    return obj;
  }

  // inserts container for EaseLive below player control bar
  let easeLiveContainer = document.createElement("div");
  easeLiveContainer.className = "easelive-container";

  player.overlay({
    content: easeLiveContainer,
  });

  var easeLive = new EaseLive({
    url: clientUrl,
    viewContainer: easeLiveContainer,
    playerPlugin: function (easeLive) {
      // event from EaseLive to change player state
      easeLive.on("player.state", function (data) {
        switch (data.state) {
          case "playing": {
            player.play();
            break;
          }
          case "paused": {
            player.pause();
            break;
          }
        }
      });

      // event from EaseLive to change player controls visibility
      easeLive.on("stage.clicked", function (data) {
        if (data.sender === "player") {
          return null;
        }

        if (data.controls === "visible") {
          player.userActive(true);
        } else {
          player.userActive(false);
        }
      });

      // notify EaseLive when player controls visibility changes
      player.on("useractive", function () {
        easeLive.emit("stage.clicked", {
          controls: "visible",
          sender: "player",
        });
      });

      player.on("userinactive", function () {
        easeLive.emit("stage.clicked", {
          controls: "hidden",
          sender: "player",
        });
      });

      // notify EaseLive when player state changes
      function onPlayerState(state) {
        easeLive.emit("player.state", {
          state: state,
        });
      }

      player.on("playing", function () {
        return onPlayerState("playing");
      });
      player.on("pause", function () {
        return onPlayerState("paused");
      });
      player.on("stalled", function () {
        return onPlayerState("buffering");
      });
      player.on("seeking", function () {
        return onPlayerState("seeking");
      });
      player.on("seeked", function () {
        return onPlayerState("playing");
      });

      // notify EaseLive when current UTC time is read from stream
      var hasId3Timecode = false;
      player.textTracks().addEventListener(
        "addtrack",
        function (addTrackEvent) {
          var track = addTrackEvent.track;

          track.addEventListener(
            "cuechange",
            function (cueChangeEvent) {
              if (track.activeCues.length <= 0) {
                return;
              }

              for (var cueIdx = 0; cueIdx < track.activeCues.length; cueIdx++) {
                var cue = track.activeCues[cueIdx];

                if (!hasId3Timecode && cue.value.dateTimeObject) {
                  // timecode from EXT-X-PROGRAM-DATE-TIME
                  var time = cue.value.dateTimeObject.getTime();
                  easeLive.emit("player.time", {
                    timecode: time,
                  });
                } else if (cue.value.data) {
                  // timecode from timed ID3 metadata

                  try {
                    var data = null;
                    if (typeof cue.value.data === "string") {
                      data = cue.value.data;
                    } else if (cue.value.data.constructor === Uint8Array) {
                      data = new TextDecoder().decode(cue.value.data);
                    }

                    if (!data || data.length == 0) {
                      return;
                    }

                    data = data.substring(
                      data.indexOf("{"),
                      1 + data.lastIndexOf("}")
                    );

                    var json = JSON.parse(data);
                    var time = parseInt(json.ut || json.utc);

                    if (!isNaN(time)) {
                      hasId3Timecode = true;
                      easeLive.emit("player.time", {
                        timecode: time,
                      });
                    }
                  } catch (e) {
                    console.error("error parsing timecode", e);
                  }
                }
              }
            },
            false
          );
        },
        false
      );

      // notify EaseLive when player is ready
      player.ready(function () {
        easeLive.emit("player.ready", {});
      });
    },
  });

  easeLive.init();

  return obj;
}
